// nullifiying a lot of the error messaging cos I don't want it in the header
import connect from 'front-end-core/decorators/connect'
import { requestSectionPrecedents } from 'services/PrecedentsService'
import React, { Component } from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import PrecedentsContentHeaderContainer from 'redux/containers/pages/precedentscontent/PrecedentsContentHeaderContainer'

@connect(({ sectionId, view, aol }) => ({
  response: requestSectionPrecedents(view === 'browse' ? 'precedents' : view, sectionId, aol)
}))
class HeaderWrapper extends Component {
  render () {
    const { response } = this.props

    return (
      <ResponseConsumer
        response={response}
        content={() => (<PrecedentsContentHeaderContainer {...this.props} />)}
        baddataComponent={null}
        notfoundComponent={null}
        notauthorizedComponent={null}
        pendingComponent={null}
      />
    )
  }
}

export default HeaderWrapper
